Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DProgramType = module.exports.default = {
	FRAGMENT: "fragment",
	VERTEX: "vertex"
};